import { Box, Link, Typography } from '@mui/material'
import { C1TextWithTruncation } from 'components/core/TextWithTruncation/C1TextWithTruncation'
import { DrawerVariants } from 'components/no-ui/context/drawer-provider'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { useDrawer } from 'hooks/useDrawer'
import { useCallback } from 'react'
import { C1DrawerLinkStyles, styles } from './styles'

type DrawerLinkProps = {
    label: string | undefined
    drawerContent: React.ReactElement
    variant?: DrawerVariants
}

/**
 * @deprecated Refer to C1DrawerLink
 */
export const DrawerLink = ({ label, drawerContent, variant = 'sm' }: DrawerLinkProps): React.ReactElement => {
    const [showDrawer] = useDrawer()

    const onClick = (): void => {
        showDrawer(drawerContent, { variant })
    }
    return (
        <Link onClick={onClick} sx={styles.link}>
            <Box component="span" sx={styles.label}>
                <Typography noWrap>
                    {label}
                </Typography>
            </Box>
        </Link>
    )
}

type C1DrawerLinkProps = {
    label: string | React.ReactElement
    drawerContent: React.ReactElement
    variant?: DrawerVariants
    /**
     * The 'dashed' variant is intended for links that open drawers of read-only content, rather than drawers with actions/forms.
     */
    linkVariant?: 'dashed' | 'default'
}

export const C1DrawerLink = ({ label, drawerContent, variant = 'sm', linkVariant = 'default' }: C1DrawerLinkProps): React.ReactElement => {
    const [showDrawer] = useDrawer()
    const onClick = useCallback((): void => {
        showDrawer(drawerContent, { variant })
    }, [showDrawer, drawerContent, variant])

    return <Link onClick={onClick} sx={sxc(C1DrawerLinkStyles.link, [linkVariant === 'dashed', C1DrawerLinkStyles.dashedVariant])}>
        {
            typeof label === 'string'
                ? <Typography component="span">
                    <C1TextWithTruncation
                        text={label}
                        textStyles={C1DrawerLinkStyles.label}
                    />
                </Typography>
                : label
        }

    </Link>
}
